

















import { Component, Vue } from 'vue-property-decorator'
// import { UserModule } from '@/store/modules/user'
import BaseClass from '../../virtual-class/baseClass'

@Component
export default class Dashboard extends BaseClass {
}
